/**
 * @license Copyright (c) 2017-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export default function sideNavigation() {
	const folderButtons = Array.from( document.querySelectorAll( '.tree:not(.api-tree) .tree__item--folder' ) );
	if( !folderButtons.length ) {
		return;
	}

	folderButtons.forEach( ( btn ) => {
		btn.addEventListener( 'click', function ( e ) {
			// Get <ul> and control it.
			btn.parentNode.nextElementSibling.classList.toggle( 'tree__item-nested-list--hidden' );
		} );
	} );
}
